import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cds-snackbar-alert ma-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (!_ctx.hide)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.hideButton)
          ? _renderSlot(_ctx.$slots, "activator", {
              key: 0,
              onClick: _ctx.openDialog,
              id: "snackbar-activator-slot"
            }, () => [
              _createVNode(_component_v_btn, {
                onClick: _ctx.openDialog,
                color: "#333",
                id: "snackbar-activator",
                size: "small"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "red",
                    icon: "mdi-alert-octagram"
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_v_snackbar, _mergeProps({
          modelValue: _ctx.snackbar,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.snackbar) = $event)),
          location: "top center"
        }, _ctx.$attrs, {
          "close-on-back": "",
          role: "alert",
          "aria-live": "assertive",
          timeout: "-1"
        }), {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn, {
              tabindex: "0",
              color: "red",
              variant: "text",
              onClick: _ctx.closeDialog
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Close ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", {
              ref: "snackbarMessage",
              tabindex: "0",
              onKeydown: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["esc"]))
            }, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.msg), 1)
              ])
            ], 544)
          ]),
          _: 3
        }, 16, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}